import React, {useContext, useCallback, useEffect, useState } from 'react'
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from 'gw-portals-validation-react';
import { WizardPage, wizardProps, WizardPageTemplate } from 'gw-portals-wizard-react';
import { fnolCommonMessages } from 'gw-capability-fnol-common-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './OtherDamagePage.metadata.json5';
import {readViewModelValue} from "gw-jutro-adapters-react";
import { CheckboxField } from '@jutro/components';
import { CheckboxGroupField } from '@jutro/components';

function FNOLOtherDamagePage(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        history: {
            location: {state = {}}
        }
    } = props;
    const {claimStatus} = state;
    const translator = useContext(TranslatorContext);

    const {
        onValidate,
        initialValidation,
        isComponentValid,
        registerInitialComponentValidation
    } = useValidation('FNOLHOOtherDamagePage');

    const initialiseVM = useCallback(() => {
        return claimVM;
    }, [claimVM]);

    useEffect(
        () => {
            const nextclaimVM = initialiseVM();
            updateWizardData(nextclaimVM);
        },
        // Call once when page gets rendered
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const overrideProps = {
        '@field': {
            showOptional: true
        }
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, claimVM, id, path, overrideProps);
        },
        [claimVM]
    );

    const resolvers = {
        resolveValue: readValue
        /*resolveCallbackMap: {
        }*/
    };

    return (
        <WizardPage
            cancelLabel={translator(fnolCommonMessages.fnolSaveandExit)}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
            disableNext={!isComponentValid}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                resolveValue={resolvers.resolveValue}
            />
        </WizardPage>
    );
}

FNOLOtherDamagePage.propTypes = wizardProps;
export default withRouter(FNOLOtherDamagePage);